export default {
  namespaced: true,
  state: () =>  ({
    show: false,
    callback: null,
    confirm: false,
    type: '',
  }),
  getters: {
    getShow: (state) => state.show,
    getCallback: (state) => state.callback,
    getConfirm: (state) => state.confirm,
    getType: (state) => state.type,
  },
  mutations: {
    setShow: (state, value) => {
      // eslint-disable-next-line no-param-reassign
      state.show = value
    },
    setType: (state, value) => {
      state.type = value
    },
    setCallback: (state, value) => {
      state.callback = value
    },
    setConfirm: (state, value) => {
      state.confirm = value
    },
  },
  actions: {
    show({commit}, { callback }) {
      commit('setCallback', callback)
      commit('setShow', true)
    },
    confirm({commit, getters}) {
      commit('setShow', false)
      commit('setConfirm', true)
      let callback = getters.getCallback
      callback()
    },
    cancel({commit}) {
      commit('setShow', false)
    },
  }
}
